<template lang="html">

  <div class="newsletter">

    <p v-html="$t('banner_newsletter.recibenoticias')"></p>

    <form class="contenedor-newsletter" id="newsletter" @submit.prevent="checkBeforeSubmit">

      <input type="text" :placeholder="$t('banner_newsletter.introduceEmail')" name="email" v-validate="'required|email'">
      <button class="btn-rounded-white" :send="send">
        <span class="send" v-html="$t('banner_newsletter.enviar')"></span>
        <span class="ok"><i class="fa fa-check" aria-hidden="true"></i></span>
      </button>

      <div class="errors">
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
      </div>
      <input type="hidden" value="iformalia" name="from">
      
      <div class="contenedor-check">
        <input type="checkbox" id="politica-newsletter" v-validate="'required'" name="politica">
        <label for="politica-newsletter" >{{$t('banner_newsletter.HeLeidoYacepto')}} <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('banner_newsletter.politica')}} </router-link></label>
      </div>

    </form>

  </div>

</template>

<script lang="js">

  import axios from 'axios';
  import VueAxios from 'vue-axios';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex'

  export default  {
    name: 'newsletter',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked : false,
        send : false
      }
    },
    methods: {
     ...mapActions(['sendNewsletter']),
     checkBeforeSubmit : function(){
      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        if(canSend){
          this.sendNewsletter($("#newsletter").serialize())
          .then(result =>{
            this.send = result;
            this.clicked = false;
            $("#newsletter")[0].reset();
          });
        }
      });
    }
  },
  computed: {

  }
}
</script>

<style scoped>
.contenedor-newsletter {
  margin-top: 10px;
  position: relative;
  padding-bottom: 20px;
}

.contenedor-newsletter input[type="text"] {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: 1px solid white;
  border-radius: 100px;
  padding: 0 20px;
  background: transparent;
  outline: none;
  color: #fff;
}

.contenedor-newsletter input::placeholder {
  color: #fff;
  opacity: 0.8;
  font-size: 12px;
  font-weight: 300;
}

.contenedor-newsletter .btn-rounded-white {
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  font-size: 14px;
  width: 100px;
  overflow: hidden;
}

.contenedor-newsletter .btn-rounded-white span {
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  transition: 0.5s;
  transition-timing-function: ease-in-out;
}

.contenedor-newsletter .btn-rounded-white span.ok {
  font-size: 30px;
  transform: translateX(-100%);
}

.contenedor-newsletter .btn-rounded-white[send="true"] .send {
  transform: translateX(100%);
}

.contenedor-newsletter .btn-rounded-white[send="true"] span.ok {
  transform: translateX(0%);
}

.errors {
  position: absolute;
  left: 0;
  bottom: -10px;
  color: #df9b15;
  font-size: 12px;
}

.errors span {
  text-align: left;
  width: 100%;
  display: inline-block;
}
@media screen and (max-width: 600px) {
  .contenedor-newsletter input {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/newsletter.vue